var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"23.2793","cy":"23.2793","r":"23.2793","fill":"#F5F4F4","key":0}),React.createElement("path",{"d":"M34.1447 23.6002C34.8962 23.9647 34.8962 25.0353 34.1447 25.3998L18.6864 32.8967C18.0222 33.2187 17.25 32.735 17.25 31.9969L17.25 17.0031C17.25 16.265 18.0222 15.7812 18.6864 16.1033L34.1447 23.6002Z","fill":"black","key":1})]);
}

Play.defaultProps = {"width":"47","height":"47","viewBox":"0 0 47 47","fill":"none"};

module.exports = Play;

Play.default = Play;
